<template>
  <div class="info-window-spacer" />
  <hr>
</template>

<script lang="ts">
export default {
  name: 'InfoWindowSpacer',
};
</script>

<style lang="scss" scoped>
.info-window-spacer {
  margin-top: 5px;
  padding-bottom: 15px;
}
</style>
